import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a27159"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dificulty mt-1 d-flex flex-flow-row-wrap font-poppins text-uppercase" }
const _hoisted_2 = {
  key: 0,
  class: "badge badge-light-success",
  style: {"color":"#9203DD","background":"#FFF"}
}
const _hoisted_3 = {
  key: 1,
  class: "badge badge-light-info",
  style: {"background":"#9203DD","color":"#FFF"}
}
const _hoisted_4 = {
  key: 2,
  class: "badge badge-light-warning",
  style: {"background":"#431A63","color":"#FFF"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "m-2" }, null, -1))
const _hoisted_6 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_7 = {
  key: 4,
  class: "badge badge-light-success"
}
const _hoisted_8 = {
  key: 5,
  class: "badge badge-light-warning"
}
const _hoisted_9 = {
  key: 6,
  class: "badge badge-light-primary"
}
const _hoisted_10 = {
  key: 7,
  class: "badge badge-light-info"
}
const _hoisted_11 = {
  key: 8,
  class: "badge badge-light-dark"
}
const _hoisted_12 = {
  key: 9,
  class: "badge badge-light-secondary"
}
const _hoisted_13 = {
  key: 10,
  class: "badge badge-light-danger"
}
const _hoisted_14 = {
  key: 11,
  class: "badge badge-light-warning"
}
const _hoisted_15 = {
  key: 12,
  class: "badge badge-light-success"
}
const _hoisted_16 = {
  key: 13,
  class: "badge badge-light-primary"
}
const _hoisted_17 = {
  key: 14,
  class: "badge badge-light-info"
}
const _hoisted_18 = {
  key: 15,
  class: "badge badge-light-dark"
}
const _hoisted_19 = {
  key: 16,
  class: "badge badge-light-secondary"
}
const _hoisted_20 = {
  key: 17,
  class: "badge badge-light-danger"
}
const _hoisted_21 = {
  key: 18,
  class: "badge badge-light-warning"
}
const _hoisted_22 = {
  key: 19,
  class: "badge badge-light-success"
}
const _hoisted_23 = {
  key: 20,
  class: "badge badge-light-primary"
}
const _hoisted_24 = {
  key: 21,
  class: "badge badge-light-info"
}
const _hoisted_25 = {
  key: 22,
  class: "badge badge-light-dark"
}
const _hoisted_26 = {
  key: 23,
  class: "badge badge-light-secondary"
}
const _hoisted_27 = {
  key: 24,
  class: "badge badge-light-danger"
}
const _hoisted_28 = {
  key: 25,
  class: "badge badge-light-warning"
}
const _hoisted_29 = {
  key: 26,
  class: "badge badge-light-success"
}
const _hoisted_30 = {
  key: 27,
  class: "badge badge-light-primary"
}
const _hoisted_31 = {
  key: 28,
  class: "badge badge-light-info"
}
const _hoisted_32 = {
  key: 29,
  class: "badge badge-light-dark"
}
const _hoisted_33 = {
  key: 30,
  class: "badge badge-light-secondary"
}
const _hoisted_34 = {
  key: 31,
  class: "badge badge-light-danger"
}
const _hoisted_35 = {
  key: 32,
  class: "badge badge-light-warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.level == 'Beginner')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Beginner"))
      : _createCommentVNode("", true),
    (_ctx.level == 'Intermediate')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Intermediate"))
      : _createCommentVNode("", true),
    (_ctx.level == 'Advanced')
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Advanced"))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.type == 'Offensive')
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Offensive"))
      : _createCommentVNode("", true),
    (_ctx.type == 'General')
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "General"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Application Security')
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Application Security"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Defensive')
      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Defensive"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Threat Intelligence')
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Threat Intelligence"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Incident Response')
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Incident Response"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Forensics')
      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Forensics"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Reverse Engineering')
      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Reverse Engineering"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Hardware')
      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Hardware"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Mobile')
      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Mobile"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Cloud')
      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Cloud"))
      : _createCommentVNode("", true),
    (_ctx.type == 'IOT')
      ? (_openBlock(), _createElementBlock("span", _hoisted_17, "IOT"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Network')
      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Network"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Web')
      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Web"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Wireless')
      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Wireless"))
      : _createCommentVNode("", true),
    (_ctx.type == 'OSINT')
      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "OSINT"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Social Engineering')
      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Social Engineering"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Malware Analysis')
      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Malware Analysis"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Cryptography')
      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Cryptography"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Steganography')
      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Steganography"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Binary Analysis')
      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Binary Analysis"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Programming')
      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Programming"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Scripting')
      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Scripting"))
      : _createCommentVNode("", true),
    (_ctx.type == 'DevOps')
      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "DevOps"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Cloud Security')
      ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Cloud Security"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Management')
      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Management"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Soft Skills')
      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Soft Skills"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Career')
      ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Career"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Certification')
      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Certification"))
      : _createCommentVNode("", true),
    (_ctx.type == 'Other')
      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Other"))
      : _createCommentVNode("", true)
  ]))
}